import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e8dd817"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import { computed, toRefs, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'primary',
    validator(value: string) {
      // The value must match one of these strings
      return ['primary', 'secondary', 'other'].includes(value);
    },
  },
  class: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['onClick'],
  setup(__props, { emit }) {

const props = __props

const slots = useSlots();

const hasDefaultSlot = computed(() => !!slots.default);



const { type, class: propClass } = toRefs(props);



function action() {
  emit('onClick');
}

const colorClass = computed((): string => {
  const base = 'text-white px-3 py-1 rounded btn';
  switch (type.value) {
    case 'primary':
      return `bg-primary hover:bg-primary-dark ${base}`;
    case 'other':
      return base;
    default:
      return `bg-secondary hover:bg-secondary-dark ${base}`;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: action,
    class: _normalizeClass([_unref(colorClass), _unref(propClass)]),
    disabled: __props.disabled
  }, [
    (!_unref(hasDefaultSlot))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(__props.label), 1)
        ], 64))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})